<template>
  <div class="container" v-if="currentBrand">
    <div id="social-footer" class="row d-flex">
      <div class="footer-social footer-content">
        <span v-if="currentBrand.facebook_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.facebook_link
                : goorderSettings.facebook_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#facebook" />
            </svg>
          </a>
        </span>
        <span v-if="currentBrand.twitter_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.twitter_link
                : goorderSettings.twitter_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#twitter" />
            </svg>
          </a>
        </span>
        <span v-if="currentBrand.instagram_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.instagram_link
                : goorderSettings.instagram_link
            "
          >
            <svg fill="none">
              <use xlink:href="#instagram" />
            </svg>
          </a>
        </span>
        <span v-if="currentBrand.snapchat_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.snapchat_link
                : goorderSettings.snapchat_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#snapchat" />
            </svg>
          </a>
        </span>
        <span v-if="currentBrand.linkedin_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.linkedin_link
                : goorderSettings.linkedin_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#linkedin" />
            </svg>
          </a>
        </span>
        <!-- <span>
          <a
            :href="
              domainBasedBrand
                ? currentBrand.googleplus_link
                : goorderSettings.googleplus_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#google_plus" />
            </svg>
          </a>
        </span> -->
        <span v-if="currentBrand.youtube_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.youtube_link
                : goorderSettings.youtube_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#youtube" />
            </svg>
          </a>
        </span>
        <span v-if="currentBrand.whatsapp_link">
          <a
            :href="
              domainBasedBrand
                ? currentBrand.whatsapp_link
                : goorderSettings.whatsapp_link
            "
            target="_blank"
          >
            <svg fill="none">
              <use xlink:href="#whatsapp" />
            </svg>
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'FooterSocial',
  computed: {
    ...mapGetters([
      '_T',
      'currentBrand',
      'all_goorder_settings',
      'domainBasedBrand',
      'currentBrand',
    ]),
    goorderSettings() {
      return this.all_goorder_settings[0] || []
    },
  },
}
</script>
<style lang="scss" scoped>
#social-footer {
  justify-content: space-around;
  align-items: baseline;
  padding-top: $px30;
  border-top: 1px solid rgba(237, 239, 244, 0.1);
  margin-top: $px10;
  .footer-social {
    span {
      a {
        svg {
          fill: $font-color;
          margin-right: $px10;
          width: $px30 !important;
          height: $px30 !important;
          path {
            &:hover {
              fill: $color-primary;
            }
          }
        }
      }
    }
  }
}
</style>
